import { z } from "zod";

export const apiErrorBodySchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
  statusCode: z.number().optional(),
  requestId: z.string().optional(),
});

export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>;

export const apiErrorEnvelopeSchema = z.object({
  error: apiErrorBodySchema,
});

export type ApiErrorEnvelope = z.infer<typeof apiErrorEnvelopeSchema>;

/** Matches docs/02-architecture.md success wrapper; P1 API will align on this shape. */
export const paginationMetaSchema = z.object({
  cursor: z.string().optional(),
  hasMore: z.boolean(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

export function apiSuccessEnvelopeSchema<T extends z.ZodType>(dataSchema: T) {
  return z.object({
    success: z.literal(true),
    data: dataSchema,
    meta: paginationMetaSchema.optional(),
  });
}
